import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

import { syncSelectedFacets } from 'store/actions/facets'
import { deleteSavedSearch, getSavedSearches } from 'store/actions/savedSearches'
import { searchFundersByParams, syncURL } from 'store/actions/search'

const SavedSearchesModal = ({ showModal, modalTitle, onDismiss, savedSearches }) => {
  const { i18n } = useTranslation()
  const t = i18n.getResourceBundle(i18n.language)
  const dispatch = useDispatch()

  const [selectedSavedSearch, setSelectedSavedSearch] = useState({})

  const handleApplySavedSearch = () => {
    if (selectedSavedSearch.searchUrl) {
      const savedUrl = new URL(selectedSavedSearch.searchUrl)
      const urlParams = new URLSearchParams(savedUrl.search.slice(1))

      dispatch(syncURL(urlParams.toString()))
      dispatch(syncSelectedFacets)
      dispatch(searchFundersByParams())
    }
    onDismiss()
  }

  const handleDeleteSavedSearch = async item => {
    await dispatch(deleteSavedSearch(item.id))
    await dispatch(getSavedSearches())
  }

  // Update component on change of savedSearches
  useEffect(() => {}, [savedSearches])

  return (
    <Dialog className="Saved-filter" open={showModal} onClose={onDismiss}>
      <DialogTitle>{modalTitle}</DialogTitle>
      <DialogContent>
        <div className="Saved-filter--list">
          {savedSearches &&
            savedSearches.map(item => {
              return (
                <div
                  data-selected={selectedSavedSearch.id === item.id}
                  key={item.id}
                  className="Saved-filter--list-item"
                >
                  <div>{item.name}</div>

                  <span
                    className="Saved-filter--list-item--selected"
                    data-selected={selectedSavedSearch.id === item.id}
                    onClick={() => setSelectedSavedSearch(item)}
                  >
                    {t.search.savedSearch.select}
                  </span>

                  <span
                    className="Saved-filter--list-item--delete"
                    onClick={() => handleDeleteSavedSearch(item)}
                  >
                    {t.search.savedSearch.delete}
                  </span>
                </div>
              )
            })}
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          className="main-button"
          disabled={false}
          onClick={handleApplySavedSearch}
          color="primary"
          variant="text"
        >
          {t.search.applyFilters}
        </Button>
        <Button
          className="Material-cards__expanded-state add"
          onClick={onDismiss}
          color="primary"
          variant="text"
        >
          {t.global.close}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default SavedSearchesModal
